export default {
  common: {
    add: {
      notes: 'Add button title',
      message: 'Add',
    },
    apply: {
      notes: 'Apply button title',
      message: 'Apply',
    },
    cancel: {
      notes: 'Cancel button title',
      message: 'Cancel',
    },
    delete: {
      notes: 'Delete button title',
      message: 'Delete',
    },
    remove: {
      notes: 'Remove button title',
      message: 'Remove',
    },
    confirmRemove: {
      notes: 'Confirm remove action title',
      message: 'Yes, remove',
    },
    ok: {
      notes: 'Ok button title',
      message: 'Ok',
    },
    retry: {
      notes: 'Retry button title',
      message: 'Retry',
    },
    save: {
      notes: 'Save button title',
      message: 'Save',
    },
    select: {
      notes: 'Select button title',
      message: 'Select',
    },
    selectAll: {
      notes: 'Select all button title',
      message: 'Select all {{total}}',
    },
    submit: {
      notes: 'Submit button title',
      message: 'Submit',
    },
    viewPdf: {
      notes: 'View pdf button title',
      message: 'View pdf',
    },
    close: {
      notes: 'Close button title',
      message: 'Close',
    },
    edit: {
      notes: 'Edit button title',
      message: 'Edit',
    },
    duplicate: {
      notes: 'Duplicate button title',
      message: 'Duplicate',
    },
    done: {
      notes: 'Done button title',
      message: 'Done',
    },
    reset: {
      notes: 'Reset button title',
      message: 'Reset',
    },
    previous: {
      notes: 'Previous button title',
      message: 'Previous',
    },
    next: {
      notes: 'Next button title',
      message: 'Next',
    },
    show: {
      notes: 'Show button title',
      message: 'Show',
    },
    hide: {
      notes: 'Hide button title',
      message: 'Hide',
    },
    undo: {
      notes: 'Undo button title',
      message: 'Undo',
    },
    confirm: {
      notes: 'Confirm button title',
      message: 'Confirm',
    },
    upload: {
      notes: 'Upload button title',
      message: 'Upload',
    },
    update: {
      notes: 'Update button title',
      message: 'Update',
    },
    doImport: {
      notes: 'Import button title',
      message: 'Import',
    },
    clearSelectionButton: {
      notes: 'Clear selection button title',
      message: 'Clear selection',
    },
    viewButton: {
      notes: 'View button title',
      message: 'View',
    },
  },
};
